import { useTranslation } from "react-i18next";
import { Button, Card, List, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import DonutChart from "../DonutChart";

type Props = {
	earnedCredits: number;
	remainingCredits: number;
	onExportPress: () => void;
};

export const CMESummaryCard = ({
	earnedCredits,
	remainingCredits,
	onExportPress,
}: Props) => {
	const { t } = useTranslation();
	const theme = useAppTheme();

	return (
		<FlatCard>
			<Card.Content>
				<Box gap={16}>
					<DonutChart
						distribution={[earnedCredits, remainingCredits]}
						radius={84}
						innerRadius={72}
						variant="progress"
					>
						<Text variant="headlineLarge">
							{earnedCredits > 0 ? `+${earnedCredits}` : 0}
						</Text>
						<Text variant="labelMedium">{t("cme.creditsEarnedTitle")}</Text>
					</DonutChart>
					<Text variant="bodySmall" style={{ textAlign: "center" }}>
						{t("cme.creditRatioCaption")}
					</Text>
					<Box>
						<List.Item
							title={t("cme.earned")}
							right={() => (
								<List.Icon
									icon={() => (
										<Text variant="titleMedium">
											{t("cme.creditsValue", { count: earnedCredits })}
										</Text>
									)}
								/>
							)}
							left={() => (
								<List.Icon
									icon={() => (
										<Box
											width={20}
											height={20}
											backgroundColor={theme.palette.success.light}
											borderRadius={4}
										/>
									)}
								/>
							)}
						/>
						<List.Item
							title={t("cme.available")}
							right={() => (
								<List.Icon
									icon={() => (
										<Text variant="titleMedium">
											{t("cme.creditsValue", { count: remainingCredits })}
										</Text>
									)}
								/>
							)}
							left={() => (
								<List.Icon
									icon={() => (
										<Box
											width={20}
											height={20}
											backgroundColor={theme.palette.progress.none}
											borderRadius={4}
										/>
									)}
								/>
							)}
						/>
					</Box>
					<Box>
						<Button
							mode="contained"
							disabled={!earnedCredits}
							onPress={onExportPress}
						>
							{t("cme.exportCertificate")}
						</Button>
						{!earnedCredits && (
							<Text variant="bodySmall" style={{ textAlign: "center" }}>
								{t("cme.exportDisabledCaption")}
							</Text>
						)}
					</Box>
				</Box>
			</Card.Content>
		</FlatCard>
	);
};
